import React from 'react';
import { 
  HelpCircle, 
  Book, 
  FileText, 
  Target, 
  Clock, 
  Users, 
  Code, 
  TrendingUp 
} from 'lucide-react';

/**
 * Компонент боковой панели с полезными ресурсами и советами
 */
const ResourcesSidebar = () => {
  const resources = [
    {
      icon: Target,
      title: 'Стратегия трансформации',
      description: 'Определите четкие цели и измеримые показатели успеха. Увяжите трансформацию с бизнес-стратегией.'
    },
    {
      icon: Users,
      title: 'Управление изменениями',
      description: 'Обеспечьте поддержку руководства и вовлечение всех уровней организации.'
    },
    {
      icon: Clock,
      title: 'Поэтапное внедрение',
      description: 'Разбейте проект на управляемые фазы с быстрыми победами для поддержания мотивации.'
    },
    {
      icon: Code,
      title: 'Выбор технологий',
      description: 'Тщательно оценивайте технологические решения, избегайте привязки к одному поставщику.'
    },
    {
      icon: FileText,
      title: 'Документирование процессов',
      description: 'Фиксируйте текущее и целевое состояние процессов, отслеживайте изменения.'
    },
    {
      icon: TrendingUp,
      title: 'Оценка эффективности',
      description: 'Регулярно анализируйте результаты и корректируйте подход.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Ресурсы и советы
      </h3>

      <div className="space-y-3">
        {resources.map((resource, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <resource.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {resource.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {resource.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-purple-50 dark:bg-purple-900/20 border border-purple-100 dark:border-purple-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <Book className="w-5 h-5 text-purple-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-purple-700 dark:text-purple-300 mb-2">
              Полезные материалы
            </h4>
            <ul className="text-xs text-purple-600 dark:text-purple-400 space-y-2">
              <li className="flex items-center">
                <FileText className="w-3.5 h-3.5 mr-1.5" />
                <span>Руководство по бережливому производству</span>
              </li>
              <li className="flex items-center">
                <FileText className="w-3.5 h-3.5 mr-1.5" />
                <span>Шаблоны для анализа бизнес-процессов</span>
              </li>
              <li className="flex items-center">
                <FileText className="w-3.5 h-3.5 mr-1.5" />
                <span>Методики оценки ROI трансформации</span>
              </li>
            </ul>
            <button className="w-full py-1.5 mt-3 text-xs bg-purple-500 text-white rounded hover:bg-purple-600 transition-colors">
              Скачать материалы
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourcesSidebar;